import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Products.css'; 

const products = [
  {
    name: 'iLAB-IS',
    title: 'Intelligent Staffing',
    desc: 'Enhance Workforce Readiness with Intelligent Talent Management',
    img: process.env.PUBLIC_URL + '/iLAB-IS_site copy.png',
  },
  {
    name: 'iLAB-Fast',
    title: 'DevSecOps Accelerator',
    desc: 'Deliver Critical Capabilities at the Speed of Need',
    img: process.env.PUBLIC_URL + '/iLAB-FAST_site copy.png',
  },
  {
    name: 'iLAB-SA',
    title: 'Geospatial/Scientific Application',
    desc: 'Achieve Total Situational Awareness with a Common Operational Picture',
    img: process.env.PUBLIC_URL + '/iLAB-SA_site copy.png',
  },
  {
    name: 'iLAB-IA',
    title: 'Intelligent Analytics',
    desc: 'Enhance Mission Effectiveness and Resilience with Predictive Intelligent Analytics',
    img: process.env.PUBLIC_URL + '/iLAB-IA_site copy.png',
  },
];

const tabImageOffsets = [-20, 5, 1.5, -7]; // Adjust for each tab
const tabImageScales = [1.02, 1.05, .98, 1.00]; // Adjust scale for each image

export default function Products() {
  const location = useLocation();
  const getTabFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const tab = parseInt(params.get('tab'), 10);
    return (Number.isInteger(tab) && tab >= 0 && tab < products.length) ? tab : 0;
  };
  const [selected, setSelected] = useState(getTabFromQuery());
  useEffect(() => {
    setSelected(getTabFromQuery());
    window.scrollTo(0, 0);
    document.title = 'Products';
    // eslint-disable-next-line
  }, [location.search]);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/product_banner.png)' }}>
        <h1 className="page-banner-title" id="products-banner-heading">
          Our Solutions
        </h1>
      </div>
      <main className="products-page-wrapper" aria-labelledby="products-banner-heading">
        <div className="products-tab-navigation" role="tablist" aria-label="Product Categories">
          {products.map((p, idx) => (
            <button
              key={p.name}
              onClick={() => setSelected(idx)}
              className={`product-tab-button ${selected === idx ? 'selected' : ''}`}
              role="tab"
              aria-selected={selected === idx}
              aria-controls={`product-panel-${idx}`}
              id={`product-tab-${idx}`}
              tabIndex={selected === idx ? 0 : -1} // Make only selected tab navigable by keyboard
            >
              <img
                src={p.img}
                alt={p.name}
                className="product-tab-button-image"
                style={{ transform: `translate(-50%, -50%) translateX(${tabImageOffsets[idx]}px) scale(${tabImageScales[idx]})` }}
              />
            </button>
          ))}
        </div>
        <div className="product-content-area" id={`product-panel-${selected}`} role="tabpanel" aria-labelledby={`product-tab-${selected}`}>
          <h2 className="product-content-title">{products[selected].name}: {products[selected].title}</h2>
          {selected === 0 && (
            <>
              <p className="product-description-highlight">
                {products[0].desc}
              </p>
              <p className="product-description-text">
                Federal agencies are under immense pressure to meet their objectives in a landscape of fierce talent competition, specialized skills shortages, and retention challenges. To succeed, you need more than just candidates; you need a strategic partner who can deliver mission-ready teams.<br /><br />
                iLAB-IS is engineered to directly address these challenges. Our solution enhances your Workforce Readiness by ensuring the right personnel are assigned to critical roles through AI-driven staffing and optimized workflows. We combine over a decade of expert recruiting with advanced AI platforms to accelerate talent acquisition, streamline processes, and deliver measurable cost savings. This empowers your teams to focus on achieving mission-critical outcomes instead of navigating staffing hurdles.<br /><br />
                Our approach to workforce transformation moves beyond simple placement . iLAB-IS is built on a holistic, lifecycle-based strategy that emphasizes not just intelligent recruitment, but also robust retention and ongoing commitment to your mission. We partner with our federal clients to forge mission-aligned teams, integrating seamless collaboration and proactive communication to build a resilient and effective workforce.<br /><br />
                The result is an empowered agency, improved program delivery, and sustained high performance. By aligning your people directly with your mission, iLAB-IS ensures your agency can deliver on its promise at its highest potential.
              </p>
              <div className="product-contact-button-container">
                <a href="/contact" className="product-contact-button">
                  Find out more
                </a>
              </div>
            </>
          )}
          {selected === 1 && (
            <>
              <p className="product-description-highlight">
                {products[1].desc}
              </p>
              <p className="product-description-text">
                Federal agencies need to deliver secure and innovative software at the speed of the mission. The iLAB-Fast DevSecOps Accelerator is engineered to provide a decisive advantage, helping government programs modernize their applications to achieve 30-50% faster deployment timelines and significant cost savings. We integrate development, security, and operations into a single, automated pipeline, enabling the rapid and secure deployment of essential digital tools.<br /><br />
                Our approach is built on a foundation of deep mission alignment, combining strategic planning with secure automation to accelerate your authority-to-operate (ATO) journey. By embedding Zero Trust security principles and leveraging advanced tooling for vulnerability management and continuous authorization, iLAB-Fast eliminates critical bottlenecks. This allows for seamless migration, real-time security enforcement, and full traceability at every stage of the lifecycle.<br /><br />
                With iLAB-Fast, your agency can evolve with confidence. We empower you to transform your digital capabilities, reduce infrastructure spending, and achieve your mission faster and more securely. Our solution delivers sustained value and optimization at every step, ensuring you stay ahead of changing requirements.
              </p>
              <div className="product-contact-button-container">
                <a href="/contact" className="product-contact-button">
                  Find out more
                </a>
              </div>
            </>
          )}
          {selected === 2 && (
            <>
              <p className="product-description-highlight">
                {products[2].desc}
              </p>
              <p className="product-description-text">
                Achieving Total Situational Awareness requires real-time intelligence and a unified operational picture. The iLAB-SA Geospatial/Scientific Application Accelerator is engineered to empower federal agencies with advanced capabilities for data integration, analysis, and visualization. Our solution provides secure, high-performance tools that transform complex data into actionable insights, facilitating faster and more informed decision-making in critical environments.<br /><br />
                We specialize in building custom, scalable geospatial and scientific applications that seamlessly integrate diverse data sources—from sensor feeds to environmental data and intelligence reports. By leveraging open-source technologies and adhering to industry best practices, iLAB-SA ensures interoperability and long-term sustainability. Our focus on user-centric design guarantees intuitive interfaces that enhance collaboration and decision support across multiple operational levels.<br /><br />
                With iLAB-SA, your agency gains a decisive advantage in understanding and responding to complex challenges. Our solution provides the clarity and precision needed to achieve mission objectives, optimize resource deployment, and maintain situational superiority across dynamic landscapes.
              </p>
              <div className="product-contact-button-container">
                <a href="/contact" className="product-contact-button">
                  Find out more
                </a>
              </div>
            </>
          )}
          {selected === 3 && (
            <>
              <p className="product-description-highlight">
                {products[3].desc}
              </p>
              <p className="product-description-text">
                In today's rapidly evolving landscape, federal agencies require more than just data; they need predictive insights to enhance mission effectiveness and resilience. The iLAB-IA Intelligent Analytics Accelerator is engineered to deliver this critical capability, transforming vast datasets into actionable intelligence that drives smarter decisions and proactive strategies.<br /><br />
                Our solution leverages advanced artificial intelligence (AI) and machine learning (ML) models to identify trends, predict outcomes, and automate data analysis. By integrating with existing systems and providing intuitive dashboards, iLAB-IA ensures that key stakeholders have immediate access to the insights they need. We focus on building scalable, secure, and transparent analytics platforms that support both strategic planning and real-time operational adjustments.<br /><br />
                With iLAB-IA, your agency can move from reactive responses to proactive decision-making. Our solution empowers you to optimize resource allocation, mitigate risks, and enhance overall mission resilience, ensuring you stay ahead of challenges and achieve your objectives with greater confidence.
              </p>
              <div className="product-contact-button-container">
                <a href="/contact" className="product-contact-button">
                  Find out more
                </a>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
}